import { Component } from 'react';
import streamPlayerLoader from 'lib/streamPlayerSdk';

const withNewPlayer = (WrappedComponent) => {
    class WithNewPlayer extends Component {
        state = {
            createStreamPlayer: null,
            isReady: false,
        };

        static getDerivedStateFromProps(props, state) {
            if (state.createStreamPlayer && state.isReady === false) {
                return {
                    isReady: true,
                };
            }

            return null;
        }

        async componentDidMount() {
            const createStreamPlayer = await streamPlayerLoader();
            this.setState({
                createStreamPlayer,
            });
        }

        render() {
            // do not pass decorator's specific props further
            // eslint-disable-next-line react/prop-types
            const { createStreamPlayer, isReady } = this.state;
            if (isReady === false) {
                return null;
            }

            return <WrappedComponent createStreamPlayer={createStreamPlayer} {...this.props} />;
        }
    }

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    WithNewPlayer.displayName = `withNewPlayer(${wrappedComponentName})`;

    return WithNewPlayer;
};

export default withNewPlayer;
